declare var MmenuLight: any;

document.addEventListener(
    "DOMContentLoaded", () => {

        const menu = new MmenuLight(
            document.querySelector("#main-menu"),
            "(max-width: 767px)"
        );

        if (!menu?.menu) {
            return;
        }

        const navigator = menu.navigation({
            slidingSubmenus: false
        });

        const drawer = menu.offcanvas();

        const menuEl = document.querySelector("a[href='#main-menu']");

        if (menuEl) {
            menuEl.addEventListener("click", (event) => {
                event.preventDefault();
                drawer.open();
            });
        }
    }
);
